import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedType } from '@store/order/selectors';
import { setSelectedType } from '@store/order/slice';
import { useGetClothTypesQuery } from '@api/baseApi';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import PatternItem from '@pages/order/patterns/PatternItem';



interface GridProps {
	animalType: AnimalTypeEnum,
}


const Grid = (props: GridProps) => {
	const { animalType } = props;
	const { t } = useTranslation('forms');
	
	const selectedType = useSelector(selectSelectedType);
	const dispatch = useDispatch();
	const updateSelectedType = (value: number | null) => dispatch(setSelectedType(value));

	const { data, isLoading, isFetching, isError } = useGetClothTypesQuery({ animalType: animalType });


	useEffect(() => {
		if (data && selectedType) {
			let selectedTypeExist = data.some(x => x.id === selectedType);

			if (!selectedTypeExist) {
				updateSelectedType(null);
			}
		}
	}, [ data, selectedType ]);

	
	if (isError) return (
		<p className='error-message'>
			{t('patterns.errorMessage')}
		</p>
	)
	
	if (isLoading || isFetching) return (
		<p className='loading-message'>
			{t('patterns.loadingMessage')}
		</p>
	)

	if (data && data.length === 0) return (
		<p className='info-message'>
			{t('patterns.emptyMessage')}
		</p>
	)
	
	return (
		<div className='patterns-grid'>
			{data && data.map(x =>
				<PatternItem
					item={x}
					onClick={updateSelectedType}
					isSelected={selectedType !== null && x.id === selectedType}
					notSelected={selectedType !== null && x.id !== selectedType}
					key={`pattern-item-id:${x.id}`} />)}	
		</div>
	);
};

export default Grid;